import { FILTER_RELATIVE_DATE_RANGE, SavedSearchDateRange } from '@creditsights/api-ui-web';
import { formatDate } from '../../../../../utils/dateUtils';

export const RELATIVE_DATE_RANGE_LABELS: Record<FILTER_RELATIVE_DATE_RANGE, string> = {
  [FILTER_RELATIVE_DATE_RANGE.LAST_24HRS]: 'Within last 24 hours',
  [FILTER_RELATIVE_DATE_RANGE.LAST_7DAYS]: 'Within last week',
  [FILTER_RELATIVE_DATE_RANGE.LAST_30DAYS]: 'Within last month',
  [FILTER_RELATIVE_DATE_RANGE.LAST_90DAYS]: 'Within last 90 days',
};

export const getDateRangeDisplayValue = (dateRange?: SavedSearchDateRange | null): string => {
  if (!dateRange || (!dateRange?.startDate && !dateRange?.endDate && !dateRange?.relativeRange)) {
    return '';
  }
  if (dateRange.relativeRange) {
    return RELATIVE_DATE_RANGE_LABELS[dateRange.relativeRange];
  }
  const startDate = formatDate(dateRange.startDate);
  const endDate = formatDate(dateRange.endDate);
  if (!dateRange.startDate) {
    return `Until ${endDate}`;
  }
  if (!dateRange.endDate) {
    return `${startDate} - present`;
  }
  return startDate === endDate ? startDate : `${startDate} - ${endDate}`;
};
